import React, { Component} from 'react';
import * as scriptUtils from './utils/scriptUtils';
import { IoMdSettings } from "react-icons/io";


class ChatChannelTopBar extends Component {
	constructor(props) {
		super(props);
	}

	render() {
    return (
      <div className="justify-around sm:justify-start flex bg-[#101115] h-12 shadow-md items-center">
        <div className="text-lg font-bold ml-4 text-white w-[244px]">
          {this.props.creatorName}
        </div>
        <IoMdSettings
          className="text-zinc-500 text-xl cursor-pointer"
          onClick={() => this.props.setIsInUserProfileFlow(true)}
        />
      </div>
    );
	}
}

export default ChatChannelTopBar;
